// React
import React, { useState, useEffect } from 'react';

// Redux
import { connect } from 'react-redux';

// Action
import { TENANT } from '../../../actions/configuration';
import { portalViewData } from '../../../data/appConstants';

// Components
import { Link } from '../../../msreact-kit/packages/html-components';
import { formatMessage } from '../../../utils/index';

// CSS
import './index.scss';

const Footer = (props) => {
  const [buildVersion, setBuildVersion] = useState([]);
  const footerContent = props?.content?.components?.footer;
  const tenantConfig = props?.tenantConfig;

  useEffect(() => {
    try {
      const json = require('../../../version.json');
      setBuildVersion(json);
    } catch {
      return false;
    }
  }, []);

  const openBuyerPortal = () => {
    window.open(process.env.REACT_APP_BUYER_BASE_URL, '_blank');
  };

  useEffect(() => {
    if (
      props.portalView === portalViewData.MOBILE ||
      props.portalView === portalViewData.TAB
    ) {
      document.body.style.overflow = 'auto';
    }
    if (props.portalView === portalViewData.TAB) {
      document.getElementById('footer').style.height = 'auto';
    }
  }, [props.portalView]);

  const currentYear = new Date().getFullYear();

  const entityText = formatMessage(footerContent?.name,currentYear);

  async function showDockPrivacySettings() {
    await customElements.whenDefined('dock-privacy-settings');
    const dockPrivacySettings = document.querySelector('dock-privacy-settings');
    dockPrivacySettings.setAttribute('visible', 'true');
  }

  return (
    <div
      id='footer'
      className={
        window.location.pathname !== '/login' &&
        (props.portalView === portalViewData.MOBILE ||
          props.portalView === portalViewData.TAB)
          ? 'footer-hidden'
          : `footer ${props.customClassName}`
      }
    >
      <div className='login-footer text -size-s'>
        <h1 className='-size-s entity-width'>{entityText}</h1>
        <div className='login-footer__container'>
          {footerContent?.menu?.map((document) => (
            <Link
              type='secondary'
              key={document.id}
              className='-size-s'
              to={document.link}
              label={document.name}
            />
          ))}
          {tenantConfig?.footer?.privacySettings && <Link
            type='secondary'
            className='-size-s'
            onClick={showDockPrivacySettings}
            label='Privacy settings'
          />}
          {process.env.REACT_APP_SELLER_TENANT_ID === TENANT.MKOSINT && (
            <Link
              type='secondary'
              className='-size-s'
              label={footerContent?.buyer?.name}
              onClick={openBuyerPortal}
            />
          )}
          {Object.keys(buildVersion).map(
            (key, index) =>
              key.indexOf('app') !== -1 && (
                <input
                  key={key.id}
                  id={index}
                  type='hidden'
                  value={`${key}:${buildVersion[key]}`}
                />
              )
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (redux_state) => ({
  portalView: redux_state.loginReducer.portalView,
  content: redux_state.ContentReducer.content,
  tenantConfig: redux_state.TenantConfigReducer.tenantConfig
});

export default connect(mapStateToProps)(Footer);
